var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"login"},[_c('img',{attrs:{"alt":"Vue logo","src":require("../assets/logokv.png")}}),_c('LoginComponent')],1)}
var staticRenderFns = []

export { render, staticRenderFns }